module.exports = __webpack_public_path__ + "media/images/social_icons/twitter-acb6fe0f997dc2582618e46d54d75b7a.png";